import { Component } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../environments/environment";
import { AlertService } from "./share/service/alert.service";
import { Meta } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { CookieConsentService } from "./share/service/cookie-consent.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent {
  partnerCode: any;

  constructor(
    private metaService: Meta,
    activatedRoute: ActivatedRoute,
    swUpdate: SwUpdate,
    alertService: AlertService,
    cookieConsent: CookieConsentService,

    translate: TranslateService
  ) {
    // MTR-1017: Clarity only starts once the user has accepted
    cookieConsent.init();

    translate.addLangs(["en", "bm"]);
    translate.setDefaultLang("en");

    const queryLang = activatedRoute.snapshot.queryParams.lang;
    if (queryLang === "en" || queryLang === "bm") {
      translate.use(queryLang);
    } else {
      let browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/en|bm/) ? browserLang : "bm");
    }

    // Get the root element
    if (environment.production) {
      swUpdate.available.subscribe((event) => {
        alertService.openSnackBar(
          "A newer version is now available. Refresh the page now to update the cache"
        );
        location.reload();
      });
      swUpdate.checkForUpdate();
    } else {
      this.metaService.updateTag({
        name: "robots",
        content: "noindex"
      });
    }
  }
}
